//console.log('[1] main.ts loaded');

const originalSetItem = sessionStorage.setItem;
sessionStorage.setItem = function (key: string, value: string) {
    originalSetItem.apply(this, [key, value]);
};

//console.log('[2] sessionStorage override complete');

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { ApplicationConfig, enableProdMode, importProvidersFrom, isDevMode } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { provideFirebaseApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideDatabase, getDatabase } from '@angular/fire/database';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { environment } from './environments/environment';
import { provideHttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { provideRouter, withHashLocation } from '@angular/router';
import { routes } from './app/app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideClientHydration } from '@angular/platform-browser';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CookiesService } from './app/services/admin services/cookies.service';
import { getFunctions, provideFunctions } from '@angular/fire/functions';

//console.log('[3] All imports loaded');

try {
    // console.log('[4] Initializing Firebase');
    const firebaseApp = initializeApp(environment.firebase);
    // console.log('[5] Firebase initialized');


    const firebaseProviders = [
        provideFirebaseApp(() => firebaseApp),
        provideAuth(() => getAuth(firebaseApp)),
        provideFirestore(() => getFirestore(firebaseApp)),
        provideDatabase(() => getDatabase(firebaseApp)),
        provideStorage(() => getStorage(firebaseApp)),
        provideFunctions(() => getFunctions(firebaseApp, 'europe-west1')),
    ];

    // console.log('[6] Firebase providers created');

    const appConfig: ApplicationConfig = {
        providers: [
            importProvidersFrom(
                MatCheckboxModule,
                MatDialogModule,
                MatDatepickerModule,
            ),
            provideRouter(routes, withHashLocation()),
            ...firebaseProviders,
            provideHttpClient(),
            provideAnimations(),
            provideClientHydration(),
            provideServiceWorker('custom-sw.js', {
                enabled: environment.production,
                registrationStrategy: 'registerImmediately'
            }),
            CookiesService
        ]
    };

    //  console.log('[7] App config created');

    if (environment.production) {
        enableProdMode();
    }

    // console.log('[8] About to bootstrap');

    bootstrapApplication(AppComponent, appConfig)
        //  .then(() => console.log('[9] Bootstrap successful!'))
        .catch(err => {
            console.error('[ERROR] Bootstrap failed:', err);
            console.error('[ERROR] Stack:', err.stack);
            // Rethrow to see in console
            throw err;
        });

} catch (error) {
    console.error('[ERROR] During setup:', error);
    console.error('[ERROR] Stack:', (error as Error).stack);
    throw error;
}